<div [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="horizontal"></fuse-navigation>
</div>